import { render, staticRenderFns } from "./WorkflowRecuperacaoDetalhesComponent.vue?vue&type=template&id=0761eaff"
import script from "./WorkflowRecuperacaoDetalhesComponent.vue?vue&type=script&lang=js"
export * from "./WorkflowRecuperacaoDetalhesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports